'use client';

import styled from 'styled-components';

import { breakpoints } from '@/styles/theme';

// Banner style presets
const styles = {
  'light-blue': {
    background: '#e8e2f4',
    color: '#1c1d1f',
  },
  'light-rose': {
    background: '#fce4e4',
    color: '#1c1d1f',
  },
};

const getStyle = (style) => styles[style] || styles['light-blue'];

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 14px 40px;
  gap: 2px;

  position: relative;

  background-color: ${({ $style }) => getStyle($style).background};
  color: ${({ $style }) => getStyle($style).color};

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 10px 40px;
    gap: 0 6px;
  }
`;

export const MessageRow = styled.span`
  display: inline;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.6;

  @media (max-width: ${breakpoints.tablet}) {
    text-align: left;
    font-size: 13px;
  }

  /* Style links in rich text */
  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }

  /* Remove paragraph margins from rich text */
  p {
    margin: 0;
    display: inline;
  }
`;

export const CountdownRow = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 600;

  @media (max-width: ${breakpoints.tablet}) {
    display: inline;
    font-size: 14px;
    margin-left: 8px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);

  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;
  padding: 0;

  background: transparent;
  border: none;
  cursor: pointer;

  color: inherit;
  opacity: 0.7;

  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }

  @media (max-width: ${breakpoints.tablet}) {
    right: 6px;
  }
`;
